const signUpUpdateStyles = {
    container: `absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 rounded-[8px] bg-white w-full max-w-[90%] sm:max-w-[400px] text-black  px-[10px] py-[20px] sm:px-[20px]`,
    closeButton: `absolute top-2 right-2`,
    dataContainer: `flex flex-col p-[0px] h-full`,
    popupheading:`flex items-center gap-[12px] mb-[13px]`,
    notify: `w-full h-auto max-w-[26px]`,
    heading: `text-center text-[16px] text-themeColor font-Suisse`,
    formContainer: `flex flex-col gap-[10px]`,
    inputContainer: 'flex flex-col gap-2',
    otpContainer: `flex flex-col gap-6 w-full`,
    checklabel:`leading-[26px] text-themeColor text-[12px]`,
    afterOtpreceivedContainer: `flex justify-between`,
    spamNote: `text-gray-500 text-[10px]`,
    resendOtp: `text-right text-primaryHeading text-[10px]`,
    edit_email: `text-right text-primaryHeading text-[12px] hover:underline`,
}

export { signUpUpdateStyles }